import { Controller } from '@hotwired/stimulus'
import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'
import { trans, LOG_REPORT_TEMPLATE_REQUIRED, LOG_REPORT_NAME_REQUIRED } from '../../translator'
import createFieldRule from '../../modules/validation/validation'

export default class extends Controller {
  static values = {
    index: Number
  }

  static targets = [
    'container', 'template'
  ]

  connect () {
    const logReports = this.element.querySelectorAll('.report')
    logReports.forEach((logReport, index) => {
      $(logReport.querySelector('.ui.dropdown')).dropdown()
      this.addLogReportValidationRules(index)
    })
  }

  addLogReportValidationRules (index) {
    const newFormRules = {
      [`log_logReports_${index}_reportTemplate`]: createFieldRule(
        `log_logReports_${index}_reportTemplate`,
        'empty',
        trans(LOG_REPORT_TEMPLATE_REQUIRED, {}, 'logs')
      ),
      [`log_logReports_${index}_name`]: createFieldRule(
        `log_logReports_${index}_name`,
        'empty',
        trans(LOG_REPORT_NAME_REQUIRED, {}, 'logs')
      )
    }

    const form = $('#form')
    const currentFormRules = form.form('setting', 'fields')
    form.form('destroy')
    form.form({
      fields: { ...currentFormRules, ...newFormRules },
      inline: true
    })
  }

  addReport () {
    const newLogReport = this.templateTarget.innerHTML
      .replace(/__name__/g, this.indexValue)
      .replace(/__report__/g, 'report')

    this.containerTarget.insertAdjacentHTML('beforeend', newLogReport)

    const $lastAddedReport = $(this.containerTarget).children().last()
    $lastAddedReport.find('.ui.dropdown').dropdown()

    this.addLogReportValidationRules(this.indexValue)

    this.indexValue++
  }

  removeReport (event) {
    const reportToRemove = event.currentTarget.closest('.report')
    const indexToRemove = reportToRemove.dataset.index

    const form = $('#form')
    form.form('remove field', `log_logReports_${indexToRemove}_reportTemplate`)
    form.form('remove field', `log_logReports_${indexToRemove}_name`)

    reportToRemove.remove()
  }
}
